import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

function fixedMenuAdmissions() {
  if (document.querySelectorAll(".js-admissions-menu").length) {
    let st = ScrollTrigger.create({
      trigger: ".js-admissions-menu",
      start: "top 120px",
      end: 'bottom 25%',
      endTrigger: ".js-admissions-end",
      pinnedContainer: ".js-admissions-wrapper",
      pin: false,
      //markers: true,
      
      onEnter: () => {
        document.querySelector(".js-admissions-menu").classList.add("fixed-header");
      },
      onEnterBack: () => {
        document.querySelector(".js-admissions-menu").classList.add("fixed-header");
      },
      onLeave: () => {
        document.querySelector(".js-admissions-menu").classList.remove("fixed-header");
      },
      onLeaveBack: () => {
        document.querySelector(".js-admissions-menu").classList.remove("fixed-header");
      },
      
    });

    const progressBar = $('.js-progress-bar');
    const progressAnimation = gsap.timeline({
      ease: 'none',
      scrollTrigger: {
        trigger: ".js-admissions-menu",
        start: "top 120px",
        end: 'bottom 15%',
        endTrigger: ".js-admissions-end",
        scrub: 0.1,
        toggleActions: "play pause play reset",
      }
    });
    progressAnimation.fromTo( progressBar, { width: "0%" }, { width: "100%" } );
  }
}


export { fixedMenuAdmissions };